import { render, staticRenderFns } from "./AkbsInputForm.vue?vue&type=template&id=63f76100&scoped=true&"
import script from "./AkbsInputForm.vue?vue&type=script&lang=js&"
export * from "./AkbsInputForm.vue?vue&type=script&lang=js&"
import style0 from "./AkbsInputForm.vue?vue&type=style&index=0&id=63f76100&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f76100",
  null
  
)

export default component.exports